import { ExtendedField } from '../../disclosure/models/loan-application.model';
import { LoanFileReference, SandboxOrOriginalLoanFile } from './sandbox-loan.model';

export interface FileDataModel {
  accountingUserName?: string;
  agencyCaseNo?: string;
  agencyCaseNoAssignmentDate?: Date;
  allBorrowerNames?: string;
  closerUserName?: string;
  commitmentReturnAddress?: string;
  commitmentReturnOption?: number;
  communityLending?: string;
  companyTypeOV?: number;
  complianceUserName?: string;
  constTILACalcMethod?: number;
  corvisaFileId1?: string;
  corvisaFileId2?: string;
  cosignerNames?: string;
  dateCreated: Date;
  dateModified: Date;
  deleted?: boolean;
  desiredCoCity?: string;
  desiredCoFax?: string;
  desiredCoName?: string;
  desiredCoPhone?: string;
  desiredCoState?: string;
  desiredCoStreet1?: string;
  desiredCoStreet2?: string;
  desiredCoZip?: string;
  docDrawerUserName?: string;
  docPrepAltLenderCode?: string;
  docTypeAsset?: number;
  docTypeEmployment?: number;
  docTypeIncome?: number;
  documentationType?: number;
  downPaymentDescOV?: string;
  downPaymentType1?: number;
  downPaymentType2?: number;
  driveStatus?: string;
  eligibleForPurchaseByGSEOV?: number;
  escrowAbsenceReason?: number;
  estimatedCreditScore?: number;
  eventInfo?: number;
  evidenceOfTitleOption?: number;
  fhaAgentId?: string;
  fhaLenderId?: string;
  fhaSponsorId?: string;
  fileCreditScore?: number;
  fileDataId?: number;
  fileName?: string;
  filePath?: string;
  fileUsed?: number;
  firstTimeHomeBuyer?: number;
  freshEligibleCB?: boolean;
  freshEligibleCBId?: number;
  gfeVersion?: number;
  giftDonorAccountInstitution?: string;
  giftDonorAccountNo?: string;
  giftDonorCity?: string;
  giftDonorCityStateZip?: string;
  giftDonorFullAddress?: string;
  giftDonorInstitutionAddress?: string;
  giftDonorName1?: string;
  giftDonorName2?: string;
  giftDonorPhone?: string;
  giftDonorState?: string;
  giftDonorStreet?: string;
  giftDonorZip?: string;
  giftFundsProvidedAtClosing?: boolean;
  giftSource?: string;
  giftTransferDate?: Date;
  grossRentalIncome?: number;
  hasNonOccCoBorrower?: boolean;
  homeBuyerEducation?: number;
  incomeAndDebtQMATRNotes?: string;
  insuringUserName?: string;
  isBusinessPurpose?: boolean;
  isConsumerPortalLoan?: boolean;
  isFLPLoan?: boolean;
  liabilityAfterForeclosure?: number;
  loanID?: string;
  loanOfficerAccess?: number;
  loanOfficerUserName?: string;
  loanProcessorUserName?: string;
  lockDeskUserName?: string;
  lockRequestComments?: string;
  lockRequestType?: number;
  loCompType?: number;
  marksmanLockId?: string;
  marksmanProspectId?: string;
  minNumber?: string;
  minOrgId?: number;
  minSequence?: number;
  mortgageBotAccountId?: string;
  occupancyType?: number;
  openerUserName?: string;
  organizationId?: number;
  orgCityOV?: string;
  orgFaxOV?: string;
  orgNameOV?: string;
  orgPhoneOV?: string;
  orgStateOV?: string;
  orgStreet1OV?: string;
  orgStreet2OV?: string;
  orgZipOV?: string;
  originalBorrowers?: string;
  otherEvidenceOfTitle?: string;
  otherUser10Name?: string;
  otherUser11Name?: string;
  otherUser12Name?: string;
  otherUser13Name?: string;
  otherUser14Name?: string;
  otherUser15Name?: string;
  otherUser16Name?: string;
  otherUser17Name?: string;
  otherUser18Name?: string;
  otherUser19Name?: string;
  otherUser20Name?: string;
  otherUser21Name?: string;
  otherUser22Name?: string;
  otherUser23Name?: string;
  otherUser24Name?: string;
  otherUser25Name?: string;
  otherUser2Access?: number;
  otherUser2Name?: string;
  otherUser3Access?: number;
  otherUser3Name?: string;
  otherUser4Access?: number;
  otherUser4Name?: string;
  otherUser5Name?: string;
  otherUser6Name?: string;
  otherUser7Name?: string;
  otherUser8Name?: string;
  otherUser9Name?: string;
  otherUserAccess?: number;
  otherUserName?: string;
  overrideInterviewer?: boolean;
  overrideULI?: boolean;
  partialPaymentOption?: number;
  positiveRentalHistory?: number;
  qcUserName?: string;
  repaymentWordingOV?: string;
  rhsCaseNoAssignmentPeriod?: number;
  sandboxOrOriginalLoanFile?: SandboxOrOriginalLoanFile;
  sandboxes?: LoanFileReference[];
  secondaryUserName?: string;
  selfEmployed?: boolean;
  servicingUserName?: string;
  shipperUserName?: string;
  spanishDocRequest?: ExtendedField<boolean>;
  subFolder?: number;
  superLoanType?: number;
  syncFileDataId?: number;
  syncFileDataId2?: number;
  syncFileName?: string;
  syncFileName2?: string;
  syncType?: number;
  thirdPartyFileName?: string;
  thirdPartyFileNamePiggyback?: string;
  tilVersionOV?: number;
  titleCurrentlyHeldInNames?: string;
  titleNamesNonBorrowers?: string;
  totalAllDebtBalances?: number;
  totalAllDebtPayments?: number;
  totalAllIncomes?: number;
  totalAllLiquidAssets?: number;
  tradeGUID?: string;
  tridLoanIdOV?: string;
  uli?: string;
  underwriterUserName?: string;
  urlaVersion?: number;
  useCustomRepaymentWording?: boolean;
  vaAgentId?: string;
  vacancyFactor?: number;
  vaLenderId?: string;
  waiveEscrow?: number;
  xSiteLoanAppId?: string;
}

export enum FileUsedType {
  Unknown = 0,
  _32 = 1, // 1003
  _34 = 2, // URLA
}
